import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApplicationWithClip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 32,
		cy: 32,
		r: 32,
		fill: "#C2DAFE"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32.6667 18.6667H36.2667C38.5069 18.6667 39.627 18.6667 40.4826 19.1026C41.2353 19.4861 41.8472 20.0981 42.2307 20.8507C42.6667 21.7063 42.6667 22.8265 42.6667 25.0667V38.9333C42.6667 41.1735 42.6667 42.2936 42.2307 43.1493C41.8472 43.9019 41.2353 44.5139 40.4826 44.8974C39.627 45.3333 38.5069 45.3333 36.2667 45.3333H27.7333C25.4931 45.3333 24.373 45.3333 23.5174 44.8974C22.7647 44.5139 22.1528 43.9019 21.7693 43.1493C21.3333 42.2936 21.3333 41.1735 21.3333 38.9333V38M37.3333 33.3333H31.3333M37.3333 28H32.6667M37.3333 38.6667H26.6667M24 29.3333V22C24 20.8954 24.8954 20 26 20C27.1046 20 28 20.8954 28 22V29.3333C28 31.5425 26.2091 33.3333 24 33.3333C21.7909 33.3333 20 31.5425 20 29.3333V24",
		stroke: "#0052CC",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgApplicationWithClip;
